/**
 * Groups of query keys that share a cache lifetime.
 *
 * This module deliberately has no imports. Auth.js reads from it, and Auth is
 * reachable from most of the model and request modules, so pulling those in
 * here would close an import cycle.
 */

/**
 * Every financials query key. These are all scoped to the active client
 * session, so they are dropped wholesale whenever that session changes.
 *
 * Keep in sync with the "Client - Financials" block in QueryOptions.js.
 *
 * @type {string[]}
 */
const FinancialsQueryKeys = [
    'fetchTalentTimePayments',
    'fetchContractProgression',
    'fetchProjectBurnSpend',
    ''
];

export {FinancialsQueryKeys};